<template>
<div :style="style">
  <v-menu class="right-top-menu-btn ml-1" v-if="!horizontal || $vuetify.breakpoint.xs">
    <v-btn icon slot="activator">
      <v-icon color="grey">more_vert</v-icon>
    </v-btn>
    <v-list>
      <v-list-tile v-for="cmd in commands" :key="cmd.name" @click="cmd.click(data.mac)" v-if="!(cmd.alive && isDisconnected)">
        <v-list-tile-action>
          <v-icon :color="cmd.color||'primary'">{{ cmd.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{ $t(cmd.description) }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
  <v-layout v-else align-center justify-space-around row>
    <v-flex v-for="cmd in commands" :key="cmd.name">
      <v-btn block flat :color="cmd.color||'primary'" @click="cmd.click(data.mac)" :disabled="cmd.alive && isDisconnected">{{ $t(cmd.description) }}</v-btn>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'GatewayItemMenu',
  mixins: [UserAuth],
  props: {
    data: {
      type: Object,
      required: true
    },
    optionCommands: {
      type: Object
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      baseCommands: [{
        name: 'reload',
        icon: 'refresh',
        description: 'gateway.reload',
        click: (mac) => this.reloadGateway(mac)
      }, {
        name: 'edit',
        icon: 'edit',
        description: 'gateway.edit',
        alive: true,
        click: (mac) => this.editGateway(mac)
      }, {
        name: 'twins',
        icon: 'backup',
        description: 'twins.backup',
        alive: true,
        click: (mac) => this.twinsGateway(mac)
      }, {
        name: 'reboot',
        icon: 'power_settings_new',
        description: 'gateway.reboot',
        alive: true,
        click: (mac) => this.rebootGateway(mac)
      }, {
        name: 'delete',
        icon: 'delete',
        description: 'gateway.delete',
        color: 'red',
        click: (mac) => this.removeGateway(mac)
      }]
    }
  },
  computed: {
    commands() {
      return [...this.baseCommands, ...(this.optionCommands || [])];
    },
    isDisconnected() {
      let now = new Date().getTime();
      let diff = now - this.data.updatedTime;
      return (diff > 10 * 60 * 1000);
    },
    style() {
      if (this.horizontal) return {
        width: '100%'
      }
      else return {}
    }
  },
  methods: {
    async reloadGateway(mac) {
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          mac: mac,
          cmd: 'reload'
        });
      } catch (err) {
        this.toast(this.$t('gateway.permission_denied'));
        return;
      }
      this.toast(this.$t('gateway.mac_reloading', {
        mac: (this.userMacInfo[mac] || {}).hostname || mac
      }));

      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) this.toast(val);
      });

      let refMac = this.$db.ref('userMacInfo').child(this.userId).child(mac);
      refMac.on('child_changed', snapshot => {
        if (snapshot.key === 'updatedTime') {
          this.toast(this.$t('gateway.mac_up', {
            mac: (this.userMacInfo[mac] || {}).hostname || mac
          }));
        }
      });

      setTimeout(() => {
        refMac.off();
        refErr.off();
      }, 5000);
    },
    async rebootGateway(mac) {
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          mac: mac,
          cmd: 'reboot'
        });
      } catch (err) {
        this.toast(this.$t('gateway.permission_denied'));
        return;
      }
      this.toast(this.$t('gateway.mac_rebooting', {
        mac: (this.userMacInfo[mac] || {}).hostname || mac
      }));

      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) this.toast(val);
      });

      setTimeout(() => {
        refErr.off();
      }, 5000);
    },
    removeGateway(mac) {
      this.$db.ref('macRemover').child(this.userId).set(mac);
      this.toast(this.$t('gateway.mac_removed', {
        mac: (this.userMacInfo[mac] || {}).hostname || mac
      }));
      this.$emit('close');
    },
    twinsGateway(mac) {
      this.$router.push(`/twins/${mac}`);
    },
    editGateway(mac) {
      this.$emit('edit');
    },
    toast(msg) {
      this.$emit('toast', msg);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/GatewayItemMenu.vue